export const BASE_CLINICAL_TRIAL = 
`${import.meta.env.VITE_API_BASE_URL}/clinical-trial`